import axios from "axios";
import axiosInstance from "./axios-service/axiosInstance";
import { getAccessToken } from "./axios-service/getToken";

const headers = {
  Accept: "application/json;odata=nometadata",
};

const accountService = {
  fetchAllAccounts: () => {
    return axiosInstance.get(
      "/accounts?$select=accountid,name,emailaddress1,itl_roletype,statecode&$filter=statecode eq 0&$orderby=createdon desc",
      {
        headers: headers,
      }
    );
  },

  fetchAssignToAccounts: () => {
    return axiosInstance.get(
      "/accounts?$select=accountid,name,emailaddress1,itl_roletype,statecode&$filter=itl_roletype eq 1&$orderby=createdon desc",
      {
        headers: headers,
      }
    );
  },

  fetchRequisitionByAccounts: () => {
    return axiosInstance.get(
      "/accounts?$select=accountid,name,emailaddress1,itl_roletype,statecode&$filter=itl_roletype eq 2&$orderby=createdon desc",
      {
        headers: headers,
      }
    );
  },

  updateAccount: async (id, obj) => {
    return axiosInstance.patch(`/accounts(${id})`, obj, {
      headers: headers,
    });
  },

  addAccount: async (obj) => {
    return axiosInstance.post("/accounts", obj, {
      headers: headers,
    });
  },

  fetchGroupDetails: async (groupIds, accessToken) => {
    const requests = groupIds.map(async (groupId) => {
      // Fetch group details
      const detailsRes = await fetch(
        `https://graph.microsoft.com/v1.0/groups/${groupId}`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      const details = await detailsRes.json();

      // Fetch group members
      const membersRes = await fetch(
        `https://graph.microsoft.com/v1.0/groups/${groupId}/members?$count=true`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            ConsistencyLevel: "eventual",
          },
        }
      );
      const members = await membersRes.json();

      return {
        id: details.id,
        name: details.displayName,
        description: details.description,
        memberCount: members.value?.length || 0,
        members: members.value || [],
      };
    });

    const results = await Promise.all(requests);
    return results;
  },

  getAdminGroupOwner: async (groupId) => {
    const token = await getAccessToken();
    return await axios.get(
      `https://graph.microsoft.com/v1.0/groups/${groupId}/owners`,
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
  },

  getInterviewerGroupOwner: async (groupId) => {
    const token = await getAccessToken();
    return await axios.get(
      `https://graph.microsoft.com/v1.0/groups/${groupId}/owners`,
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
  },

  removeUserFromGroup: async (groupId, userId) => {
    const token = await getAccessToken();
    return await axios.delete(
      `https://graph.microsoft.com/v1.0/groups/${groupId}/members/${userId}/$ref`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  fetchUsers: async (query) => {
    const token = await getAccessToken();
    return await axios.get(
      `https://graph.microsoft.com/v1.0/users?$filter=startswith(userPrincipalName,'${query}') or startswith(displayName,'${query}')`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
  addUserToGroup: async (group, selectedUser) => {
    const token = await getAccessToken();
    return await axios.post(
      `https://graph.microsoft.com/v1.0/groups/${group}/members/$ref`,
      {
        "@odata.id": `https://graph.microsoft.com/v1.0/directoryObjects/${selectedUser}`,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
};

export default accountService;
